export const About = ()=>{
    return(
        <>
     <div id="about" className="our-services section">
     <div className="container">
      <div className="row">
        <div className="col-lg-6 align-self-center  wow fadeInLeft" data-wow-duration="1s" data-wow-delay="0.2s">
          <div className="left-image">
          <img src="assets/images/about.png" width="350em" height="350em" alt="person graphic" />
          </div>
        </div>
        <div className="col-lg-6 wow fadeInRight mt-5" data-wow-duration="1s" data-wow-delay="0.2s">
          <div className="section-heading">
            <h2>A <em>Propos</em></h2>
            <h4 style={{fontWeight:"normal"}} className="text-black mt-3">Nous avons développé cette plateforme pour offrir aux contribuables une option pratique et efficace pour payer leurs impôts et pénalités. Notre équipe travaille en étroite collaboration avec les autorités fiscales pour garantir la sécurité et la simplicité de chaque transaction en ligne.</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
        </>
    )
}